import React, { useEffect, useState } from 'react'
import { useAuthServices } from '../../services/useFetch';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle, faEnvelope, faPhone, faMapMarkerAlt, faIdCard, faEdit } from '@fortawesome/free-solid-svg-icons';
import { Paginador } from '../Paginacion/Paginador';
import './clientes.css';

export const ListaClientes = ({ onEditarCliente }) => {

    const { requestPost } = useAuthServices();

    const [clientes, setClientes] = useState([])
    const [executeConsulta, setExecuteConsulta] = useState(false);
    const [paginacion, setPaginacion] = useState({
        totalElementos: '0',
        elementosPorPagina: '6',
        paginaActual: '1'
    });

    useEffect(() => {
        consultaCompanysService()
    }, [])

    const consultaCompanysService = async () => {
        const usuarioLocalStorage = sessionStorage.getItem('usuarioApp');
        let idCompany = 0;
        if (!!usuarioLocalStorage) {
            const usuarioLocalStorageObj = JSON.parse(usuarioLocalStorage)
            idCompany = usuarioLocalStorageObj.idCompany;
        }
        const body = {
            idCompany: idCompany
        }
        const response = await requestPost(body, 15);
        if (!response.error) {
            const { estado, objeto } = response.data
            if (estado) {
                setClientes(objeto)
                setPaginacion(prev => ({
                    ...prev,
                    totalElementos: (objeto || []).length.toString()
                }));
            }
        }
    }

    const getPaginatedClientes = () => {
        const indexPage = (parseInt(paginacion.paginaActual, 10) - 1) * parseInt(paginacion.elementosPorPagina, 10);
        const limitPage = indexPage + parseInt(paginacion.elementosPorPagina, 10);
        return (clientes || []).slice(indexPage, limitPage);
    };

    return (
        <div className="div-mis-clientes-container">
            <h4 className="mb-4">Nuestros clientes registrados:</h4>
            <div className="row m-0">
                {
                    getPaginatedClientes().length > 0 ?
                        getPaginatedClientes().map((cliente) => (
                            <div key={cliente.id} className="col-12 col-md-6 col-lg-6 mb-4">
                                <div className="card-cliente">
                                    <div className="card-cliente-header">
                                        <h5 className="cliente-full-name">{cliente.nombres} {cliente.apellidos}</h5>
                                        <div className="cliente-doc-info">
                                            <FontAwesomeIcon icon={faIdCard} className="me-2" />
                                            {cliente.tipoDocumento}: {cliente.numeroIdentificacion}
                                        </div>
                                    </div>
                                    <div className="card-cliente-body">
                                        <div className="info-item-cliente">
                                            <div className="icon-cliente-detail">
                                                <FontAwesomeIcon icon={faMapMarkerAlt} />
                                            </div>
                                            <div>
                                                <span className="label-info-cliente-small">Dirección</span>
                                                {cliente.direccion || 'No registrada'}
                                            </div>
                                        </div>
                                        <div className="info-item-cliente">
                                            <div className="icon-cliente-detail">
                                                <FontAwesomeIcon icon={faEnvelope} />
                                            </div>
                                            <div>
                                                <span className="label-info-cliente-small">Correo Principal</span>
                                                {cliente.correo1}
                                            </div>
                                        </div>
                                        {cliente.correo2 && (
                                            <div className="info-item-cliente">
                                                <div className="icon-cliente-detail">
                                                    <FontAwesomeIcon icon={faEnvelope} className="opacity-50" />
                                                </div>
                                                <div>
                                                    <span className="label-info-cliente-small">Correo Secundario</span>
                                                    {cliente.correo2}
                                                </div>
                                            </div>
                                        )}
                                        <div className="info-item-cliente">
                                            <div className="icon-cliente-detail">
                                                <FontAwesomeIcon icon={faPhone} />
                                            </div>
                                            <div>
                                                <span className="label-info-cliente-small">Teléfono Principal</span>
                                                {cliente.telefono1}
                                            </div>
                                        </div>
                                        {cliente.telefono2 && (
                                            <div className="info-item-cliente">
                                                <div className="icon-cliente-detail">
                                                    <FontAwesomeIcon icon={faPhone} className="opacity-50" />
                                                </div>
                                                <div>
                                                    <span className="label-info-cliente-small">Teléfono Secundario</span>
                                                    {cliente.telefono2}
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                    <div className="card-cliente-footer">
                                        <button
                                            className="btn-editar-cliente"
                                            onClick={() => onEditarCliente && onEditarCliente(cliente)}
                                            title="Editar cliente"
                                        >
                                            <FontAwesomeIcon icon={faEdit} className="me-1" /> Editar
                                        </button>
                                    </div>
                                </div>
                            </div>
                        ))
                        :
                        <div className="col-12 text-center py-5">
                            <div className="div-container-no-data-agenda py-5">
                                <FontAwesomeIcon icon={faExclamationTriangle} size="3x" className="text-muted mb-3" />
                                <p className="p-label-form">No se encontraron clientes registrados en el sistema.</p>
                            </div>
                        </div>
                }
            </div>
            <Paginador
                elementsPaginacion={paginacion}
                setElementsPaginacion={setPaginacion}
                setExecuteConsulta={setExecuteConsulta}
                executeConsulta={executeConsulta}
            />
        </div>
    )
}
